import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { KNEEL_RESPONSE_OPTIONS } from '@/pages/Onboarding/options/KneelResponse/KNEEL_RESPONSE_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../../OwnAI_Dominate/components/Title';
import { DominateFooter } from '../../components/DominateFooter';
import { LayoutDataType } from '../../types';

import { PageStyles } from './KneelResponse.styles';

export const ScreenKneelResponse: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'KneelResponse',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const kneelResponse = form.watch('kneel_response');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['kneel_response']>,
  ) => {
    form.setValue('kneel_response', option.id);
  };

  const handleNextStep = (): void => {
    userService.createOrUpdate({
      onboarding_data: {
        kneel_response: kneelResponse,
      },
    });
    wizard.nextStep();
  };

  const handleBack = () => {
    wizard.goToStep('control_response');
  };

  return (
    <PageStyles background={'domination'}>
      <OnboardingNavigation onBack={handleBack} />
      <OwnAiTitle>If I asked you to kneel...</OwnAiTitle>
      <IonContent>
        <OnboardingOptionsList disableTopSpacing>
          {KNEEL_RESPONSE_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={kneelResponse === option.id}
              control={form.control}
              option={option}
              name="kneel_response"
              key={option.id}
              onChange={() => handleSelect(option)}
              TEST_ID={`kneel-response-${option.id}`}
              theme={'domination-transparent'}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>

      {kneelResponse && (
        <DominateFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
          quoteText="Good. I hate waiting."
          buttonText="I'll follow"
          variant="with-quotes"
        />
      )}
    </PageStyles>
  );
};
